import platform from "Pub/js/platform";
const { pageTo } = platform;
export function pageToWithMsgType(newMsgType) {
    if (!pageTo.openTo) {
        throw new Error("引入plantform包pageTo方法有误");
    }
    let openWithMsgType = pageTo.openTo;
    switch (newMsgType) {
        // 跳审批
        case "approve":
            openWithMsgType(
                "/nccloud/resources/uap/msgcenter/message/main/index.html",
                {
                    appcode: "10160501"
                }
            );
            break;
        // 跳业务
        case "todo":
            openWithMsgType(
                "/nccloud/resources/uap/msgcenter/message/main/index.html?msgType=todo",
                {
                    appcode: "10160502"
                }
            );
            break;
        // 跳预警
        case "prealert":
            openWithMsgType(
                "/nccloud/resources/uap/msgcenter/message/main/index.html?msgType=prealert",
                {
                    appcode: "10160503"
                }
            );
            break;
        // 跳通知
        case "notice":
            openWithMsgType(
                "/nccloud/resources/uap/msgcenter/message/main/index.html?msgType=notice",
                {
                    appcode: "10160504"
                }
            );
            break;
        default:
            break;
    }
}
